import {cloneDeep} from 'lodash';
import {getArray, getNumber, getString, resetObjectValues} from 'Core/helpers/data';
import {ViberCarouselItemButtonDataObject, ViberCarouselItemDataObject} from '../dataObjects';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ViberCarouselItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ViberCarouselItemDataObject(
		getString(result, 'id'),
		getString(result, 'title'),
		getString(result, 'imageUrl'),
		getArray(result, 'buttons').sort((a, b) => a.ordinal - b.ordinal).map(b => new ViberCarouselItemButtonDataObject(
			getString(b, 'id'),
			getString(b, 'label'),
			getString(b, 'actionUrl'),
			getNumber(b, 'ordinal', 1),
		)),
		getNumber(result, 'ordinal', 1),
	);

	return result;
}

/**
 * Get output data from input data
 * @param {ViberCarouselItemDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep({
		id: inputData.id,
		title: inputData.title,
		imageUrl: inputData.image,
		buttons: getArray(inputData.buttons).map(b => ({
			id: b.id,
			label: b.label,
			actionUrl: b.action,
			ordinal: b.ordinal,
		})),
		ordinal: inputData.ordinal,
	});

	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}